import * as cx from 'classnames';
import * as React from 'react';
import styles from './LoadingPlaceholder.mscss';

interface OwnProps {
    className?: string;
    width: number | string;
    height?: number | string;
    style?: any;
}

const LoadingPlaceholder: React.StatelessComponent<OwnProps> = ({ className, width, height, style }) => (
    height && height !== '100%' ? (
        <div className={cx(className, styles.LoadingPlaceholderParent)}>
            <div className={styles.LoadingPlaceholder} style={{ ...style, width, height }}/>
        </div>
    ) : (
        <div className={cx(className, styles.LoadingPlaceholder)} style={{ ...style, width, height }}/>
    )
);

export default LoadingPlaceholder;
